<template>
	<div class="box">
		<arrorImg  bg="white"></arrorImg>
		<navBar title="中奖记录" color="#ffffff"></navBar>
		<div class="content-box">
			<div class="content" v-if="!isEmpaty">
				 <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
				<li class="consume-item" v-for="(item,index) in winList" :key="index" >
					<div class="consum-left">
						<img v-if="item.prizeType==2" src="../../../static/coupon_icon.png"  alt="">
						<img  v-if="item.prizeType==0" src="../../../static/unsign.png" alt="">
						<img v-if="item.prizeType==1" src="../../../static/rember_icon.png" alt="">
						<span>{{item.prizeName}}</span>
					</div>
					<div class="consum-right">
						<span>{{item.luckdrawDate}}</span>
					</div>
				</li>
				 </ul>
				<div class="load-more">
						<span>{{ !isLoading ?'加载中':loadText }}</span>
				</div>
			</div>
			<div class="no-log" v-else>
				<img  src="../../../static/no-log.png" alt="">
				<span>暂无记录~</span>
			</div>
			
		</div>
	</div>
</template>
<script>
	import {Toast, MessageBox } from "mint-ui";
	import arrorImg from "../../components/arrow-img.vue";
	import navBar from '../components/navbar.vue'
	export default {
		components: {
			arrorImg,
			navBar
		},
		data() {
			return {
				loading:false,
				isEmpaty: false,
				pageNo: 1,
				winList: [],
				loadText: '加载中...',
				pageCount: 1,
				isEntranceData:'',
				isLoading:false,
				pageType:''
			}
		},
		mounted() {
			if(this.$route.query.isEntranceData){
				this.isEntranceData=this.$route.query.isEntranceData
			}
			this.pageType=this.$route.query.pageType;
			var openid =  this.$base.getStorage('openid')
			var isWxAuthorized =  this.$base.getStorage('isWxAuthorized');
			    var city = this.$base.getStorage("city");
			if (!openid) { //静默登录手动登录
				// #ifdef H5
				// #endif
			} else if(isWxAuthorized==0&&city==1&&openid&&!this.$store.state.user.isSNS){
				 this.$base.setStorage('isSNS',true)
				this.$store.state.user.isSNS=true;
				this.$commonApi.snsapiUserinfo();
				this.findLuckRecordList();
				this.insertPageAccessData();
			} else {
			
				this.findLuckRecordList();
				this.insertPageAccessData();
			}
			this.$commonApi.share();
		},
		methods:{
				  loadMore() {
		this.loading = true;
         if (this.pageCount > this.pageNo) {
          this.pageNo += 1;
          this.findLuckRecordList();
        } else {
          	this.loading = false;
          this.loadText = "没有更多了";
        }
		},

			insertPageAccessData() {
				var pageName='';
				if(this.pageType=='bookMine'){
					pageName='我的'
				}else if (this.pageType === "bookCurrency") {
					pageName = "书币";
					}else if (this.pageType === "bookCharge") {
						pageName = "充值中心";
					} else if (this.pageType === "bookCity") {
						pageName = "书城";
					} 
				   var params = {
				       pageName: '抽奖列表',
				       pageRemark: '上级页面:'+pageName,
					   isEntranceData:this.isEntranceData
				     }
				this.$api.insertPageAccessData(params).then(res => {
			
				})
			},
			findLuckRecordList() {
				var params = {
					pageNo: this.pageNo,
					pageSize: 10
				}
				this.isLoading=false;
				this.$api.findLuckRecordList(params).then(res => {
					if (res.status == 1) {
						this.pageCount = res.pages;
						if (this.pageNo == 1) {
							this.winList = res.data;
							if (this.pageCount <= 1) {
								this.loadText = '没有更多了'
							} else {
								this.loadText = '加载中...'
							}
						} else {
							this.winList = this.winList.concat(res.data);
						}
						if (this.winList.length == 0) {
							this.isEmpaty = true;
						}else{
							this.isEmpaty = false;
						}
						this.isLoading=true;

					}
				})

			}
		}

	}
</script>

<style scoped>
	.box{
		/* height:calc(48px + env(safe-area-inset-bottom)); */
		  padding-bottom: constant(safe-area-inset-bottom);
		/* 兼容 iOS < 11.2 */
		padding-bottom:env(safe-area-inset-bottom);
		/* 兼容 iOS >= 11.2 */
		/* box-sizing: content-box; */
	}
	.content {
		padding-left:16px;
		border-top:1px solid #F3F3F3;
	}
	.content-box{
		padding-top:calc(44px + env(safe-area-inset-top));
	}

	.consume-item {
		display: flex;
		width: 100%;
		justify-content: space-between;
		padding: 20px 0px;
	border-bottom: 1px solid #F3F3F3;
	}
	.consum-left {
		display: flex;
	}
	.consum-left>span {
		font-size: 14px;
		font-weight: bold;
		color: #333333;
	}

	.consum-left>img{
		width: 20px;
		height: 20px;
		margin-right: 20px;
	}
.consum-right{
	padding-right:16px;
}
	.consum-right>span {
		color: #aaaaaa;
		font-size: 12px
	}
	.load-more {
		text-align: center;
		  font-size: 12px;
color: #AAAAAA;
   padding: 16px 0px;
	}

	.no-log {
		text-align: center;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.no-log img {
		width: 128px;
		height: 128px;
		display: block;
		margin: 0 auto;

	}

	.no-log span {
		display: block;
		font-size: 14px;
		color: #666666;
		margin-top: 20px;
	}

</style>



// WEBPACK FOOTER //
// src/view/winRecord/index.vue